import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Escandallo/editarEscandallo`, method: 'POST', body: values, token: token})
}